import React from 'react';
import { useAuthGuard } from '../../hooks/useAuthGuard';
import "./ProtectedRoute.scss";
interface ProtectedRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fallback,
  redirectTo = '/'
}): React.ReactElement | null => {
  const { isAuthenticated, isLoading } = useAuthGuard({ redirectTo });

  // Afficher un loader pendant la vérification
  if (isLoading) {
    return fallback ? <>{fallback}</> : (
      <div className="auth-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  // Si non authentifié, le hook useAuthGuard gère déjà la redirection
  if (!isAuthenticated) {
    return null;
  }

  // Si authentifié, afficher le contenu protégé
  return <>{children}</>;
};